<template>
  <div class="card">
    <div class="title" v-show="title">
      <slot name="title"></slot>
    </div>
    <div class="body" v-show="body">
      <slot name="body"></slot>
    </div>
    <div class="footer" v-show="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    title: {
      type: Boolean,
      required: false,
      default: true
    },
    body: {
      type: Boolean,
      required: false,
      default: true
    },
    footer: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>
